import { createActions, createReducer } from "reduxsauce"
import * as Immutable from "seamless-immutable"

// const preKeys = getDefaultPath();
const tag = "[APP_REDUX]"

const functionDefinitions = {
  startup: null
}

const { Types, Creators } = createActions(functionDefinitions)
export const AppReduxTypes = Types
export default Creators

export const AppInitState = {}

export const INITIAL_STATE = Immutable(AppInitState)

export const startup = state => {
  console.log(`${tag} Startup caught in appSaga/startup function`)
  return state.merge(AppInitState)
}

export const reducer = createReducer(INITIAL_STATE, {
  [Types.STARTUP]: startup
})



// WEBPACK FOOTER //
// ./src/redux/app/appRedux.ts